/* script */




















































































































import { defineComponent, reactive } from "@vue/composition-api";
import { railsDirectUploadsPath } from "../lib/rails-routes";

const __vue_script__ = defineComponent({
  props: {
    individual: {
      type: Boolean,
      required: true,
    },
    companyUrl: {
      type: String,
      required: true,
    },
  },
  setup(props) {
    const state = reactive({ individual: props.individual });
    const handleChangeIndividual = (event: any): void => {
      state.individual = event.target.value === "1";
    };

    return {
      state,
      handleChangeIndividual,
      url: props.companyUrl,
      railsDirectUploadsPath: railsDirectUploadsPath(),
    };
  },
});

/* template */
var __vue_render__ = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _c("div", { staticClass: "row form-group" }, [
      _c("label", { staticClass: "col-sm-3" }, [_vm._v("法人・個人")]),
      _vm._v(" "),
      _c("div", { staticClass: "col-sm-9" }, [
        _c("span", { staticClass: "radio" }, [
          _c("label", [
            _c("input", {
              attrs: {
                type: "radio",
                name: "seller[company_attributes][individual]",
                value: "0",
              },
              domProps: { checked: !_vm.state.individual },
              on: { change: _vm.handleChangeIndividual },
            }),
            _vm._v("\n          法人\n        "),
          ]),
        ]),
        _vm._v(" "),
        _c("span", { staticClass: "radio" }, [
          _c("label", [
            _c("input", {
              attrs: {
                type: "radio",
                name: "seller[company_attributes][individual]",
                value: "1",
              },
              domProps: { checked: _vm.state.individual },
              on: { change: _vm.handleChangeIndividual },
            }),
            _vm._v("\n          個人\n        "),
          ]),
        ]),
      ]),
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "row form-group" }, [
      _c("label", { staticClass: "col-sm-3" }, [_vm._v("URL")]),
      _vm._v(" "),
      _c("div", { staticClass: "col-sm-9" }, [
        _c("input", {
          staticClass: "form-control",
          attrs: {
            type: "url",
            name: "seller[company_attributes][url]",
            placeholder: "https://example.com",
          },
          domProps: { value: _vm.url },
        }),
      ]),
    ]),
    _vm._v(" "),
    !_vm.state.individual
      ? _c("div", { staticClass: "row form-group" }, [
          _c("label", { staticClass: "col-sm-3" }, [_vm._v("登記事項証明書")]),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "col-sm-9" },
            [
              _c("div", { staticClass: "input-group" }, [
                _c("div", { staticClass: "custom-file" }, [
                  _c("input", {
                    staticClass: "custom-file-input",
                    attrs: {
                      id: "certificate_of_registration",
                      type: "file",
                      name: "seller[owner_seller_item_attributes][certificate_of_registration]",
                      "data-direct-upload-url": _vm.railsDirectUploadsPath,
                    },
                  }),
                  _vm._v(" "),
                  _c(
                    "label",
                    {
                      staticClass: "custom-file-label",
                      attrs: { for: "certificate_of_registration" },
                    },
                    [_vm._v("ファイル選択")]
                  ),
                ]),
              ]),
              _vm._v(" "),
              _c(
                "VDropdown",
                {
                  scopedSlots: _vm._u(
                    [
                      {
                        key: "popper",
                        fn: function () {
                          return [
                            _c("div", { staticClass: "text-sm" }, [
                              _c("p", [
                                _vm._v(
                                  "\n              存在確認のため法務局または、オンラインで取得した\n              履歴事項全部証明書を提出してください。\n            "
                                ),
                              ]),
                              _vm._v(" "),
                              _c("div", { staticClass: "font-weight-bold" }, [
                                _vm._v("【※注意事項※】"),
                              ]),
                              _vm._v(" "),
                              _c("ul", { staticClass: "mb-0" }, [
                                _c("li", [
                                  _vm._v("発行から３ヶ月以内のものが有効"),
                                ]),
                                _vm._v(" "),
                                _c("li", [
                                  _vm._v(
                                    "添付データはすべてのページを１つのファイルにして添付してください。"
                                  ),
                                ]),
                                _vm._v(" "),
                                _c("li", [
                                  _vm._v(
                                    "登録情報と一致しているデータを添付してください。"
                                  ),
                                ]),
                              ]),
                            ]),
                          ]
                        },
                        proxy: true,
                      },
                    ],
                    null,
                    false,
                    3926806045
                  ),
                },
                [
                  _c(
                    "a",
                    {
                      attrs: { href: "#" },
                      on: {
                        click: function ($event) {
                          $event.preventDefault()
                        },
                      },
                    },
                    [_vm._v("何を添付すれば良いですか？")]
                  ),
                ]
              ),
            ],
            1
          ),
        ])
      : _vm._e(),
    _vm._v(" "),
    _c("div", { staticClass: "row form-group" }, [
      _c("label", { staticClass: "col-sm-3" }, [
        _vm._v(_vm._s(_vm.state.individual ? "確定申告書" : "名刺・決算書")),
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "col-sm-9" }, [
        _c("div", { staticClass: "input-group" }, [
          _c("div", { staticClass: "custom-file" }, [
            _c("input", {
              staticClass: "custom-file-input",
              attrs: {
                id: "attachments_for_owner_seller_review",
                type: "file",
                multiple: "",
                name: "seller[owner_seller_item_attributes][attachments_for_owner_seller_review][]",
                "data-direct-upload-url": _vm.railsDirectUploadsPath,
              },
            }),
            _vm._v(" "),
            _c(
              "label",
              {
                staticClass: "custom-file-label",
                attrs: { for: "attachments_for_owner_seller_review" },
              },
              [_vm._v("ファイル選択")]
            ),
          ]),
        ]),
        _vm._v(" "),
        _vm.state.individual
          ? _c(
              "div",
              [
                _c(
                  "VDropdown",
                  {
                    scopedSlots: _vm._u(
                      [
                        {
                          key: "popper",
                          fn: function () {
                            return [
                              _c("div", { staticClass: "text-sm" }, [
                                _c("p", [
                                  _vm._v(
                                    "存在確認のため、確定申告のコピーを提出してください。"
                                  ),
                                ]),
                                _vm._v(" "),
                                _c("div", { staticClass: "font-weight-bold" }, [
                                  _vm._v("【※注意事項※】"),
                                ]),
                                _vm._v(" "),
                                _c("ul", { staticClass: "mb-0" }, [
                                  _c("li", [
                                    _vm._v(
                                      "添付データはすべてのページを１つのファイルにして添付してください。"
                                    ),
                                  ]),
                                  _vm._v(" "),
                                  _c("li", [
                                    _vm._v(
                                      "登録情報と一致しているデータを添付してください。"
                                    ),
                                  ]),
                                ]),
                              ]),
                            ]
                          },
                          proxy: true,
                        },
                      ],
                      null,
                      false,
                      3759156264
                    ),
                  },
                  [
                    _c(
                      "a",
                      {
                        attrs: { href: "#" },
                        on: {
                          click: function ($event) {
                            $event.preventDefault()
                          },
                        },
                      },
                      [_vm._v("何を添付すれば良いですか？")]
                    ),
                  ]
                ),
              ],
              1
            )
          : _vm._e(),
      ]),
    ]),
  ])
}
var __vue_staticRenderFns__ = []
__vue_render__._withStripped = true

  /* style */
  const __vue_inject_styles__ = undefined
  /* scoped */
  const __vue_scope_id__ = undefined
  /* module identifier */
  const __vue_module_identifier__ = undefined
  /* functional template */
  const __vue_is_functional_template__ = false
  /* component normalizer */
  function __vue_normalize__(
    template, style, script,
    scope, functional, moduleIdentifier, shadowMode,
    createInjector, createInjectorSSR, createInjectorShadow
  ) {
    const component = (typeof script === 'function' ? script.options : script) || {}

    // For security concerns, we use only base name in production mode.
    component.__file = "app/javascript/src/containers/OwnerSellerFileContainer.vue"

    if (!component.render) {
      component.render = template.render
      component.staticRenderFns = template.staticRenderFns
      component._compiled = true

      if (functional) component.functional = true
    }

    component._scopeId = scope

    if (false) {
      let hook
      if (false) {
        // In SSR.
        hook = function(context) {
          // 2.3 injection
          context =
            context || // cached call
            (this.$vnode && this.$vnode.ssrContext) || // stateful
            (this.parent && this.parent.$vnode && this.parent.$vnode.ssrContext) // functional
          // 2.2 with runInNewContext: true
          if (!context && typeof __VUE_SSR_CONTEXT__ !== 'undefined') {
            context = __VUE_SSR_CONTEXT__
          }
          // inject component styles
          if (style) {
            style.call(this, createInjectorSSR(context))
          }
          // register component module identifier for async chunk inference
          if (context && context._registeredComponents) {
            context._registeredComponents.add(moduleIdentifier)
          }
        }
        // used by ssr in case component is cached and beforeCreate
        // never gets called
        component._ssrRegister = hook
      }
      else if (style) {
        hook = shadowMode 
          ? function(context) {
              style.call(this, createInjectorShadow(context, this.$root.$options.shadowRoot))
            }
          : function(context) {
              style.call(this, createInjector(context))
            }
      }

      if (hook !== undefined) {
        if (component.functional) {
          // register for functional component in vue file
          const originalRender = component.render
          component.render = function renderWithStyleInjection(h, context) {
            hook.call(context)
            return originalRender(h, context)
          }
        } else {
          // inject component registration as beforeCreate hook
          const existing = component.beforeCreate
          component.beforeCreate = existing ? [].concat(existing, hook) : [hook]
        }
      }
    }

    return component
  }
  /* style inject */
  
  /* style inject SSR */
  
  /* style inject shadow dom */
  

  
  const __vue_component__ = /*#__PURE__*/__vue_normalize__(
    { render: __vue_render__, staticRenderFns: __vue_staticRenderFns__ },
    __vue_inject_styles__,
    __vue_script__,
    __vue_scope_id__,
    __vue_is_functional_template__,
    __vue_module_identifier__,
    false,
    undefined,
    undefined,
    undefined
  )

  export default __vue_component__